import { TranslationInfo } from "@shared/types/translation-info";

export const PROJECT_MODULE_TRANSLATION_SCOPE: string = "feature/project-modules";
export const PROJECT_MODULE_TRANSLATIONS: Record<string, TranslationInfo> = {
  "access-control": {
    defaultText: "Zutrittskontrolle",
    token: "label-access-control",
    scope: PROJECT_MODULE_TRANSLATION_SCOPE
  },
  "access-terminals": {
    defaultText: "Zuko-Terminals",
    token: "label-access-terminals",
    scope: PROJECT_MODULE_TRANSLATION_SCOPE
  },
  "minimum-wage": {
    defaultText: "Mindestlohn",
    token: "label-minimum-wage",
    scope: PROJECT_MODULE_TRANSLATION_SCOPE
  },
  reports: {
    defaultText: "Auswertungen",
    token: "label-reports",
    scope: PROJECT_MODULE_TRANSLATION_SCOPE
  },
  "area-management": {
    defaultText: "Flächenmanagement",
    token: "label-area-management",
    scope: PROJECT_MODULE_TRANSLATION_SCOPE
  },
  "transport-management": {
    defaultText: "Transportmanagement",
    token: "label-transport-management",
    scope: PROJECT_MODULE_TRANSLATION_SCOPE
  },
  "attendance-list": {
    defaultText: "Anwesenheitsliste",
    token: "label-attendance-list",
    scope: PROJECT_MODULE_TRANSLATION_SCOPE
  },
  "employee-data": {
    defaultText: "Mit Mitarbeiter-Angaben",
    token: "label-employee-data",
    scope: PROJECT_MODULE_TRANSLATION_SCOPE
  },
  "without-employee-data": {
    defaultText: "Ohne Mitarbeiter-Angaben",
    token: "label-without-employee-data",
    scope: PROJECT_MODULE_TRANSLATION_SCOPE
  },
  "employee-data-times-summed": {
    defaultText: "Mit Mitarbeiter-Angaben | Zeiten summiert",
    token: "label-employee-data-times-summed",
    scope: PROJECT_MODULE_TRANSLATION_SCOPE
  },
  "without-employee-data-times-summed": {
    defaultText: "Ohne Mitarbeiter-Angaben | Zeiten summiert",
    token: "label-without-employee-data-times-summed",
    scope: PROJECT_MODULE_TRANSLATION_SCOPE
  },
  "employee-data-checkin-checkout": {
    defaultText: "Mit Komm- und Gehzeit",
    token: "label-employee-data-checkin-checkout",
    scope: PROJECT_MODULE_TRANSLATION_SCOPE
  },
  "employee-data-checkin-checkout-times-summed": {
    defaultText: "Mit Komm- und Gehzeit | Zeiten summiert",
    token: "label-employee-data-checkin-checkout-times-summed",
    scope: PROJECT_MODULE_TRANSLATION_SCOPE
  },
  "without-employee-data-pivot": {
    defaultText: "Anwesenheit Pivot",
    token: "label-without-employee-data-pivot",
    scope: PROJECT_MODULE_TRANSLATION_SCOPE
  },
  "employee-data-checkin-checkout-times-summed-with-employee": {
    defaultText: "Anwesenheitsliste mit Mitarbeiter-Angaben + Komm- und Gehzeiten + Zeiten summiert",
    token: "label-employee-data-checkin-checkout-times-summed-with-employee",
    scope: PROJECT_MODULE_TRANSLATION_SCOPE
  },
  "identification-card-overview": {
    defaultText: "Ausweisübersicht",
    token: "label-identification-card-overview",
    scope: PROJECT_MODULE_TRANSLATION_SCOPE
  },
  "employee-data-identification-card": {
    defaultText: "Mit Mitarbeiter-Angaben",
    token: "label-employee-data-identification-card",
    scope: PROJECT_MODULE_TRANSLATION_SCOPE
  },
  "without-employee-data-identification-card": {
    defaultText: "Ohne Mitarbeiter-Angaben",
    token: "label-without-employee-data-identification-card",
    scope: PROJECT_MODULE_TRANSLATION_SCOPE
  }
};
